import { Alert, Typography, styled } from "@mui/material";

function UserAlert({ severity, title, description, action }) {
  const renderSeverity = (id) => {
    const types = { 1: "info", 2: "success", 3: "warning", 4: "error" };

    return types[id];
  };

  return (
    <AlertStyle severity={renderSeverity(severity)} dir="rtl" action={action}>
      <Typography fontWeight={600} variant="subtitle1" color="text.main">
        {title}
      </Typography>
      <Typography variant="subtitle2" color="text.main">
        {description}
      </Typography>
    </AlertStyle>
  );
}

const AlertStyle = styled(Alert)(({ theme, severity }) => ({
  padding: theme.spacing(0.5, 1),
  margin: theme.spacing(0, 0.5),
  background: theme.palette.background.alert,
  borderRadius: "8px",
  ".MuiAlert-message": {
    padding: theme.spacing(0),
    color: theme.palette.text.light,
  },

  ".MuiAlert-icon": {
    marginRight: "0",
    marginLeft: theme.spacing(1),
    color:
      severity === "warning"
        ? theme.palette.warning.secondary
        : severity === "info"
        ? theme.palette.info.lightest
        : severity === "error"
        ? theme.palette.error.main
        : theme.palette.success.secondary,
  },

  ".MuiAlert-action": {
    marginLeft: theme.spacing(-1),
    marginRight: "auto",
    color: theme.palette.text.main,
  },
}));

export default UserAlert;
